/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const autoUpdate = false;
export const baiduMap = false;
export const i18nBackendLoadPath = '/locales/{{lng}}/{{ns}}.json';
export const baseURL = 'https://backend.dev.soundtalksweb.com';
// export const baseURL = 'http://localhost:8000';
export const captchaKey = '0x4AAAAAAAJhWLXu3G1uiQeN';
export const reversedFullName = false;
export const apkDownloadUrl = null;
export const isDemo = false;
export const isChinaConfig = true;
export const enableSubscription = false;
export const wechatAppId = 'wx6754d7df320c7e03';
export const allowedDownloadDomains = [
  'soundtalks-dev-s3-backend-batch-exports.s3.eu-west-1.amazonaws.com', // Batch exports
  'd1yfw06htk050d.cloudfront.net', // Audio snippets
];

export const themeColors = {
  '--st-color-ai': '#00263A',
};
